module.exports = __webpack_public_path__ + "img/10.494a8b8a.jpg";